import moment from "moment-timezone";
import FormatDateHelper from "helper/FormatDateHelper";

export const NTT_FT_OKINAWA_SEASON_ID = "cmkdxxnxn000141s4asb2gdfv";
export const NTT_FT_OITA_SEASON_ID = "cmvto6100000108phdaocdk18";

export const isNttFtGameProdSeason = (seasonIds) => (
  Array.isArray(seasonIds)
  && seasonIds.length === 1
  && [NTT_FT_OKINAWA_SEASON_ID, NTT_FT_OITA_SEASON_ID].includes(seasonIds[0])
);

export const isNttFtOkinawaSeason = (seasonIds) => (
  Array.isArray(seasonIds)
  && seasonIds.length === 1
  && seasonIds[0] === NTT_FT_OKINAWA_SEASON_ID
);

export const buildNttFtRegisteredAssetCountQuery = (seasonId) => ({
  query: `
    SELECT pa.type, COUNT(*) AS count
    FROM power_asset_state pas
    JOIN power_asset pa ON pa.id = pas.power_asset_id
    WHERE pas.game_space_id = '${seasonId}'
    GROUP BY pa.type;`,
  database: "KpiDashboard",
  type: "list",
});

export const sumNttFtRegisteredAssetCounts = (response) => {
  if (!Array.isArray(response) || response.length === 0) return null;
  const counts = response.map((row) => Number(row && row.count));
  if (counts.some((count) => !Number.isFinite(count))) return null;
  return counts.reduce((total, count) => total + count, 0);
};

export const toNttFtUtcBounds = (dateRange) => ({
  startUtc: moment
    .tz(`${dateRange[0]} 00:00:00`, "Asia/Tokyo")
    .utc()
    .format("YYYY-MM-DD HH:mm:ss"),
  endUtc: moment
    .tz(`${dateRange[1]} 00:00:00`, "Asia/Tokyo")
    .add(1, "day")
    .utc()
    .format("YYYY-MM-DD HH:mm:ss"),
});

export const buildNttFtPhotoShootTrendQuery = ({ seasonId, dateRange, grain = "day" }) => {
  const { startUtc, endUtc } = toNttFtUtcBounds(dateRange);
  const bucket = grain === "hour"
    ? "DATE_FORMAT(DATE_ADD(pae.occurred_datetime, INTERVAL 9 HOUR), '%Y-%m-%d %H:00')"
    : "DATE(DATE_ADD(pae.occurred_datetime, INTERVAL 9 HOUR))";

  return {
    query: `
      SELECT
        ${bucket} AS bucket,
        COUNT(*) AS photograph_event_count,
        COUNT(DISTINCT pae.player_id) AS unique_player_count
      FROM power_asset_event pae
      WHERE pae.game_space_id = '${seasonId}'
        AND pae.type = 'PHOTOGRAPH'
        AND pae.occurred_datetime >= '${startUtc}'
        AND pae.occurred_datetime < '${endUtc}'
      GROUP BY bucket
      ORDER BY bucket ASC;`,
    database: "KpiDashboard",
    type: "list",
  };
};

export const normalizeNttFtPhotoCountResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (response && response.bucket !== undefined) return [response];
  if (response && Array.isArray(response.body)) return response.body;
  if (response && response.body && response.body.bucket !== undefined) return [response.body];
  if (response && response.total_photo_power_assets !== undefined) return [response];
  if (response && response.body && response.body.total_photo_power_assets !== undefined) return [response.body];
  if (response && typeof response.body === "string") {
    try { return normalizeNttFtPhotoCountResponse(JSON.parse(response.body)); } catch (e) { return []; }
  }
  return [];
};

const normalizeRows = normalizeNttFtPhotoCountResponse;

const rowValue = (row, key, fallbackKey) => {
  const value = row && row[key] !== undefined ? row[key] : row && row[fallbackKey];
  return value == null ? 0 : Number(value);
};

const normalizeBucket = (bucket, grain) => {
  if (bucket == null) return "";
  const value = String(bucket);
  if (grain === "hour") {
    return value.includes("T")
      ? moment.utc(value).format("YYYY-MM-DD HH:mm")
      : value.slice(0, 16);
  }
  return value.includes("T")
    ? moment.utc(value).format("YYYY-MM-DD")
    : value.slice(0, 10);
};

export const normalizeNttFtPhotoShootTrend = ({ response, dateRange, grain = "day" }) => {
  const rows = normalizeRows(response);
  const dates = grain === "hour"
    ? FormatDateHelper.getHoursListBetweenDays(dateRange[0], dateRange[1])
    : FormatDateHelper.getDaysListBetweenDays(dateRange[0], dateRange[1]);
  const rowByBucket = new Map(rows.map((row) => [
    normalizeBucket(row.bucket || row.DAY || row.HOUR, grain),
    row,
  ]));

  return {
    date: dates,
    countDenchu: dates.map((date) => rowValue(rowByBucket.get(date), "photograph_event_count", "shooting_count")),
    unique: dates.map((date) => rowValue(rowByBucket.get(date), "unique_player_count", "unique_photographer_count")),
    newUser: dates.map(() => null),
  };
};
